import { create } from 'zustand'
import { useHandStore } from './handStore'

export type AppView = 'intro' | 'site'
export type AppPhase = 'idle' | 'shrinking' | 'curtain' | 'done' | 'returning'

type AppStoreState = {
  currentView: AppView
  phase: AppPhase
  /** burst 计数器，每次自增 → Fireworks 组件以此触发新的烟花 */
  fireworksTrigger: number

  /** 由 DropBox 命中触发：1.5s shrink+烟花 + 0.8s 下拉转场 */
  triggerLab: () => void
  /** 由 ESC / 跳过按钮触发：跳过 shrink，直接 0.8s 下拉 */
  skipToLab: () => void
  /** 官网内左上角"返回引导页"按钮 */
  backToIntro: () => void
}

const SHRINK_MS = 1500
const CURTAIN_MS = 800
const RETURN_MS = 800

export const useAppStore = create<AppStoreState>((set, get) => ({
  currentView: 'intro',
  phase: 'idle',
  fireworksTrigger: 0,

  triggerLab: () => {
    if (get().phase !== 'idle') return
    set((s) => ({ phase: 'shrinking', fireworksTrigger: s.fireworksTrigger + 1 }))
    window.setTimeout(() => {
      if (get().phase !== 'shrinking') return
      set({ phase: 'curtain' })
    }, SHRINK_MS)
    window.setTimeout(() => {
      set({ phase: 'done', currentView: 'site' })
    }, SHRINK_MS + CURTAIN_MS)
  },

  skipToLab: () => {
    if (get().phase !== 'idle') return
    set({ phase: 'curtain' })
    window.setTimeout(() => {
      set({ phase: 'done', currentView: 'site' })
    }, CURTAIN_MS)
  },

  backToIntro: () => {
    if (get().currentView !== 'site') return
    // 清掉 hand 跨 view 残留的 pinch 状态，避免 SceneRoot 重新挂载后
    // Cube.useFrame 立刻 lerp 到上一次的 hand target（dropbox 附近）→ 重复触发
    useHandStore.getState().release()
    set({ phase: 'returning' })
    window.setTimeout(() => {
      set({ phase: 'idle', currentView: 'intro' })
    }, RETURN_MS)
  },
}))

export const transitionTimings = {
  shrinkMs: SHRINK_MS,
  curtainMs: CURTAIN_MS,
  returnMs: RETURN_MS,
}
